module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapno"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "chapname"
  }, [_vm._v("Leadership Fundamentals")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/pg1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In his search to be a great leader, the young centurion"), _c('br'), _vm._v("sought out the Republic’s veteran warrior. Looking up"), _c('br'), _vm._v("from his labor, the sage spoke: “I know not what beats"), _c('br'), _vm._v("beneath your tunic, but what I saw in a leader from"), _c('br'), _vm._v("foot soldiers to proconsul is thus:")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("One who makes drill bloodless combat"), _c('br'), _vm._v("and combat bloody drill…"), _c('br'), _vm._v("One who disciplines the offense and not the offenders…"), _c('br'), _vm._v("One whose heart is with the Legion and whose loyalty"), _c('br'), _vm._v("is to the Republic…"), _c('br'), _vm._v("One who seeks the companionship of the long march"), _c('br'), _vm._v("and not the privilege of position…"), _c('br'), _vm._v("One whose commission is assigned from above and"), _c('br'), _vm._v("confirmed from below…"), _c('br'), _vm._v("One who knows the self and, therefore, is true to all…"), _c('br'), _vm._v("One who seeks to serve and not to be served…"), _c('br'), _vm._v("This is the one who leads best of all.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFFREY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PARA")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61820324","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/09_Chapter01.vue
// module id = 84
// module chunks = 0